import BaseComponent from "../../BaseComponent";

/**
 * Warn manager about respondents below payout threshold.
 * Add extra confirm when manager tries to payout them.
 * Show the total amount of selected respondents in the payout confirm.
 */
export default class ToPayOutGridWarnings extends BaseComponent {

    private $grid: JQuery;
    private $respondents: JQuery;
    private $alert: JQuery;
    private respondentsMessage: string;
    private alertMessage: string;
    private confirmDefault: string;
    private confirmBelowThreshold: string;
    private currency: string;
    private exchangeRate: number;
    private pointsUnit: string;

    public init(): void {
        this.$grid = this.$component.nextAll('.datagrid').first();
        if (this.$grid.length === 0) {
            return;
        }

        this.$respondents = this.$component.find('[data-below-threshold-respondents]');
        this.$alert = this.$component.find('[data-below-threshold-alert]');
        this.respondentsMessage = this.$component.data('respondents-message');
        this.alertMessage = this.$component.data('alert-message');
        this.currency = this.$component.data('currency');
        this.exchangeRate = Number(this.$component.data('exchange-rate'));
        this.pointsUnit = this.$component.data('points-unit');

        const $button = this.$grid.find('[data-group-action-external]');
        this.confirmDefault = $button.data('confirm');
        this.confirmBelowThreshold = $button.data('confirm-below-threshold');

        this.$grid.on('datagrid:groupActionsChanged', () => this.recalc());
    }

    private recalc(): void {
        const $checkedRows = this.$grid
            .find('input[name*="grid_group_action_item"]:checked')
            .closest('tr');
        const $belowThresholdChecked = $checkedRows.filter('.below-threshold');
        const amount = this.formatAmount(this.sumAmount($checkedRows));

        const count = $belowThresholdChecked.length;
        const $button = this.$grid.find('[data-group-action-external]');

        if (count > 0) {
            this.$respondents.text(this.translator.choice(this.respondentsMessage, count));
            this.$alert.text(this.translator.choice(this.alertMessage, count));
            this.$component.show();
            $button.data('confirm', this.confirmBelowThreshold.split('%amount%').join(amount));
        } else {
            this.$component.hide();
            $button.data('confirm', this.confirmDefault.split('%amount%').join(amount));
        }
    }

    private sumAmount($rows: JQuery): number {
        return $rows.toArray().reduce((sum, row) => sum + (Number($(row).data('amount')) || 0), 0);
    }

    /**
     * Mirrors RewardFacade::getFormattedRewardValue(). Fraction digits are fixed because PHP's
     * NumberFormatter renders 2 decimals for every supported currency, while Intl drops them e.g. for HUF.
     */
    private formatAmount(points: number): string {
        const value = points / this.exchangeRate;

        if (this.currency === 'points') {
            return `${value}\u00a0${this.pointsUnit}`;
        }

        return new Intl.NumberFormat(this.translator.locale.replace('_', '-'), {
            style: 'currency',
            currency: this.currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    }
}
